import { useEffect, useState } from 'react';
import './ProjectSetting.scoped.scss';
import emitCreateProject from '../../../connector/emits/createProject';
import { openAlert } from '../../../atoms/common';
import { getRecoil } from 'recoil-nexus';
import { projectTypesState } from '../../../atoms/service';
import Chip1000 from "../../../assets/img/chip1000.png";
import Chip5000 from "../../../assets/img/chip5000.png";
import Chip10000 from "../../../assets/img/chip10000.png";
import Chip50000 from "../../../assets/img/chip50000.png";
import Chip100000 from "../../../assets/img/chip100000.png";
import Chip500000 from "../../../assets/img/chip500000.png";
import Chip1000000 from "../../../assets/img/chip1000000.png";
import roomDetailState from '../../../atoms/roomDetail';

const ProjectSetting = () => {
  const roomDetail = getRecoil(roomDetailState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const projectTypes = getRecoil(projectTypesState);

  const [selectedProjectType, setSelectedProjectType] = useState('');
  const [projectPrice, setProjectPrice] = useState('');
  const [projectStartAmount, setProjectStartAmount] = useState('');
  const [projectTargetAmount, setProjectTargetAmount] = useState('');

  useEffect(() => {
    setSelectedProjectType(projectTypes[0]);
  }, [projectTypes]);

  const createProjectSetting = () => {
    const nProjectPrice = Number(projectPrice);
    const nProjectStartAmount = Number(projectStartAmount);
    const nProjectTargetAmount = Number(projectTargetAmount);

    if (isNaN(nProjectPrice) || nProjectPrice < 10 || nProjectPrice % 10 !== 0) {
      return openAlert("'참가비용'은 10개 단위로만 설정이 가능합니다.");
    }
    
    if (isNaN(nProjectStartAmount) || nProjectStartAmount === 0) {
      return openAlert("'시작금액'은 0이 아닌 숫자만 입력해야합니다.");
    }

    if (isNaN(nProjectTargetAmount) || nProjectTargetAmount === 0) {
      return openAlert("'목표금액'은 0이 아닌 숫자만 입력해야합니다.");
    }

    emitCreateProject(
      roomDetail.id,
      selectedProjectType,
      nProjectPrice,
      nProjectStartAmount,
      nProjectTargetAmount,
    );
  };

  const addProjectStartAmount = (_amount: number) => {
    let nAmount = Number(projectStartAmount);
    nAmount = (isNaN(nAmount) || nAmount <= 0) ? 0 : nAmount; 

    let fAmount = nAmount + _amount;

    setProjectStartAmount(fAmount.toString());
  }

  const resetProjectStartAmount = () => {
    setProjectStartAmount('');
  }

  const addProjectTargetAmount = (_amount: number) => {
    let nAmount = Number(projectTargetAmount);
    nAmount = (isNaN(nAmount) || nAmount <= 0) ? 0 : nAmount; 

    let fAmount = nAmount + _amount;

    setProjectTargetAmount(fAmount.toString());
  }

  const resetProjectTargetAmount = () => {
    setProjectTargetAmount('');
  }

  return (
    <div className="project-setting">
      <div className="project-setting__left">
        <div className="project-setting__row">
          <div className="project-setting__row__title">프리미엄 타입</div>
          <select
            className="project-setting__project-setting-select"
            value={selectedProjectType}
            onChange={(e) => setSelectedProjectType(e.target.value)}
          >
            {projectTypes.map((projectType, i) => (
              <option value={projectType} key={i}>{projectType}</option>
            ))}
          </select>
        </div>
        <div className="project-setting__row">
          <div className="project-setting__row__title">참가비용</div>
          <input className="project-setting__project-setting-input" value={projectPrice} onChange={(e) => setProjectPrice(e.target.value)} />
          <span>보석</span>
        </div>
        <div className="project-setting__row">
          <div className="project-setting__row__title">시작금액</div>
          <input className="project-setting__project-setting-input" value={projectStartAmount} onChange={(e) => setProjectStartAmount(e.target.value)} />
          <span>원</span>
          <button className="project-setting__project-setting-fn-button" onClick={() => resetProjectStartAmount()}>리셋</button>
        </div>
        <div>
          <button
            className="pick__pick-amount-button"
            style={{ marginLeft: '121px' }}
            onClick={() => addProjectStartAmount(1000)}
          >
            <img src={Chip1000} alt="천원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectStartAmount(5000)}
          >
            <img src={Chip5000} alt="오천원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectStartAmount(10000)}
          >
            <img src={Chip10000} alt="만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectStartAmount(50000)}
          >
            <img src={Chip50000} alt="오만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectStartAmount(100000)}
          >
            <img src={Chip100000} alt="십만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectStartAmount(500000)}
          >
            <img src={Chip500000} alt="오십만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectStartAmount(1000000)}
          >
            <img src={Chip1000000} alt="백만원"/>
          </button>
        </div>
        <div className="project-setting__row">
          <div className="project-setting__row__title">목표금액</div>
          <input className="project-setting__project-setting-input" value={projectTargetAmount} onChange={(e) => setProjectTargetAmount(e.target.value)} />
          <span>원</span>
          <button className="project-setting__project-setting-fn-button" onClick={() => resetProjectTargetAmount()}>리셋</button>
        </div>
        <div>
          <button
            className="pick__pick-amount-button"
            style={{ marginLeft: '121px' }}
            onClick={() => addProjectTargetAmount(1000)}
          >
            <img src={Chip1000} alt="천원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectTargetAmount(5000)}
          >
            <img src={Chip5000} alt="오천원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectTargetAmount(10000)}
          >
            <img src={Chip10000} alt="만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectTargetAmount(50000)}
          >
            <img src={Chip50000} alt="오만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectTargetAmount(100000)}
          >
            <img src={Chip100000} alt="십만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectTargetAmount(500000)}
          >
            <img src={Chip500000} alt="오십만원"/>
          </button>
          <button
            className="pick__pick-amount-button"
            onClick={() => addProjectTargetAmount(1000000)}
          >
            <img src={Chip1000000} alt="백만원"/>
          </button>
        </div>
      </div>
      <div className="project-setting__right">
        <button onClick={createProjectSetting}>프리미엄 시작</button>
      </div>
    </div>
  );
};

export default ProjectSetting;
